/* eslint-disable */
import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

interface SlackRecipientsProps {
  channel?: string;
  user?: string;
  onChannelChange: (channel: string | undefined) => void;
  onUserChange: (user: string | undefined) => void;
}

export const SlackRecipients: React.FC<SlackRecipientsProps> = ({
  channel,
  user,
  onChannelChange,
  onUserChange,
}) => {
  const recipientTypeLabelId = 'reports-recipient-type-label';
  const [recipientType, setRecipientType] = useState<'channel' | 'user'>(
    channel ? 'channel' : user ? 'user' : 'channel'
  );

  const handleRecipientTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newType = event.target.value as 'channel' | 'user';
    setRecipientType(newType);
    // Clear the other field when switching types
    if (newType === 'channel') {
      onUserChange(undefined);
    } else {
      onChannelChange(undefined);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Recipient
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id={recipientTypeLabelId}>Recipient Type</InputLabel>
        <Select
          labelId={recipientTypeLabelId}
          value={recipientType}
          label="Recipient Type"
          onChange={(e) =>
            handleRecipientTypeChange(
              e as React.ChangeEvent<HTMLInputElement>
            )
          }
        >
          <MenuItem value="channel">Channel</MenuItem>
          <MenuItem value="user">User (DM)</MenuItem>
        </Select>
        <FormHelperText>
          Select whether to send to a Slack channel or user DM
        </FormHelperText>
      </FormControl>

      {recipientType === 'channel' ? (
        <TextField
          fullWidth
          label="Channel ID"
          value={channel || ''}
          onChange={(e) => onChannelChange(e.target.value || undefined)}
          placeholder="C1234567890"
          helperText="Enter Slack channel ID (e.g., C1234567890)"
          InputLabelProps={{ shrink: true }}
        />
      ) : (
        <TextField
          fullWidth
          label="User ID"
          value={user || ''}
          onChange={(e) => onUserChange(e.target.value || undefined)}
          placeholder="U1234567890"
          helperText="Enter Slack user ID for DM (e.g., U1234567890)"
          InputLabelProps={{ shrink: true }}
        />
      )}
    </Box>
  );
};
